import { render } from "./beacon.vue?vue&type=template&id=cece035c&scoped=true"
import script from "./beacon.vue?vue&type=script&lang=js"
export * from "./beacon.vue?vue&type=script&lang=js"

import "./beacon.vue?vue&type=style&index=0&id=cece035c&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cece035c"]])

export default __exports__